// Kept free of React and the API client — and of api.ts's types, which drag
// the browser in with them: the Worker in worker/ imports it to pick the
// picture behind a product's link preview. Generic over the image, so callers
// get their ApiProductImage back.

/** The fields of an ApiProductImage this module reads. */
export interface ImageRef {
  id: string;
  publicUrl: string;
  alt?: string;
  isPrimary: boolean;
  isAdditional?: boolean;
  topColor?: string;
  legColor?: string;
}

/**
 * The one image that stands for a product in a grid: product-level primary
 * first, then any colour's primary, then anything at all. Never an additional
 * photo: the grid keeps its bundled photography sooner than show one.
 *
 * Mirrors Product.PrimaryImage on the API side, so the picture in the grid is
 * the one the admin was shown when they set it.
 */
export function primaryImage<T extends ImageRef>(product: { images?: T[] }): T | undefined {
  const images = (product.images ?? []).filter((i) => !i.isAdditional);
  return (
    images.find((i) => !i.topColor && !i.legColor && i.isPrimary) ??
    images.find((i) => i.isPrimary) ??
    images[0]
  );
}
